import React, { createContext, useContext, useState } from 'react'
import Store from './store'

const StoreContext = createContext({} as Store)

export const MainStoreProvider = ({ children }: { children: React.ReactNode}) => {
  const [store] = useState(() => new Store())

  return (
    <StoreContext.Provider value={store}>
      {children}
    </StoreContext.Provider>
  )
}

export const useMainStore = () => {
  const store = useContext(StoreContext)
  return store
}
